import { css } from 'lit';

export const style = css`
  .mobile-view {
    margin-left: auto;
    margin-right: auto;
    width: 295px;
  }

  .offer-details {
    align-items: center;
    display: flex;
    flex-direction: row;
    flex-wrap: nowrap;
    justify-content: space-evenly;
  }

  .offer-details-left {
    justify-content: flex-end;
    text-align: right;
  }

  .selected-payment {
    display: flex;
    justify-content: flex-end;
  }

  #selected-term,
  #selected-apr {
    padding-bottom: 8px;
  }

  .desktop-view {
    flex-direction: column;
    gap: 12px;
    justify-content: center;
    margin-left: auto;
    margin-right: auto;
    max-width: 508px;
  }

  .payment-div {
    display: flex;
  }

  .middle-div {
    align-self: center;
    display: flex;
    gap: 16px;
    height: 56px;
  }

  .mobile-vertical-divider {
    background: #d4d4d4;
    height: 84px;
    min-width: 1px;
    width: 1px;
  }

  .vertical-divider {
    background: #d4d4d4;
    height: 56px;
    width: 1px;
  }

  .vertical-divider-small {
    background: #d4d4d4;
    height: 24px;
    width: 1px;
  }

  .pill-div {
    display: flex;
    justify-content: center;
  }

  .pill-div-small {
    display: flex;
    justify-content: center;
    padding-top: 8px;
  }

  .mobile-view-small {
    display: flex;
    flex-direction: column;
    margin-left: auto;
    margin-right: auto;
    width: 238px;
  }

  .payment-div-small {
    align-self: center;
    display: flex;
    height: 55px;
  }

  .term-apr-div {
    align-self: center;
    display: flex;
    gap: 8px;
    height: 24px;
    width: 177px;
  }

  @media screen and (max-width: 374px) {
    .mobile-view-small {
      display: flex;
    }

    .mobile-view {
      display: none;
    }

    .desktop-view {
      display: none;
    }
  }

  @media screen and (min-width: 375px) and (max-width: 743px) {
    .mobile-view-small {
      display: none;
    }

    .mobile-view {
      display: block;
    }

    .desktop-view {
      display: none;
    }
  }

  @media screen and (min-width: 744px) {
    .mobile-view-small {
      display: none;
    }

    .mobile-view {
      display: none;
    }

    .desktop-view {
      display: flex;
    }
  }
`;
